<template>
  <div class="form_west-side">
    <div class="row">
      <div class="column">
        <p class="modal__label">Позиция и период размещения</p>
        <div class="row">
          <el-form-item
            prop="inputPosition"
            class="task-position"
            v-model="inputPosition"
            @change="visibleChangeHandler"
            :disabled="mode !== 'double'"
            :rules="[
            { required: true, message: 'Position is required'},
            { type: 'number', message: 'Position must be a number'}
            ]"
          >
            <el-input type="number" placeholder="" class="input_position" :disabled="mode !== 'double'" v-model.number="parentData.inputPosition"></el-input>
          </el-form-item>

          <div class="block">
            <el-form-item
              prop="dateSpace"
              :rules="[ { required: true, message: 'Daterange is required'} ]"
            >
              <el-date-picker
                ref="picker"
                v-model="parentData.dateSpace"
                type="daterange"
                align="right"
                start-placeholder="From"
                end-placeholder="To"
                format="dd.MM.yy"
                range-separator="/"
                :unlink-panels="true"
                :clearable="false"
                :picker-options="pickerOptions"
                :default-time="['00:00:00', '23:59:59']">
              </el-date-picker>
            </el-form-item>
          </div>
        </div>
      </div>
      <div class="column _ml-15">
        <p class="modal__label">Количество просмотров</p>
          <el-form-item
            prop="inputCountView"
          >
            <el-input type="number" placeholder="" v-model.number="parentData.inputCountView"></el-input>
          </el-form-item>
      </div>
    </div>
    <div class="row _mt-15">
      <div class="column upload-desktop">
        <p class="modal__label">Desktop</p>
        <el-upload
          action="#"
          list-type="picture-card"
          accept=" .jpg, .jpeg, .png"
          :on-change="handleImage"
          :multiple="false"
          :auto-upload="false">
          <i slot="default" class="el-icon-plus"></i>
          <img v-if="parentData.backgroundSrc" 
            class="el-upload--picture-uploaded" 
            slot="default" :src="parentData.backgroundSrc">
          <div slot="file" slot-scope="{file}">
            <img
              class="el-upload-list__item-thumbnail"
              :src="file.url" alt=""
            />
            <span class="el-upload-list__item-actions">
              <span
                class="el-upload-list__item-preview"
                @click="handlePictureCardPreview(file)"
              >
                <i class="el-icon-zoom-in"></i>
              </span>
              <span
                v-if="!disabled"
                class="el-upload-list__item-delete"
                @click="handleRemove(file)"
              >
                <i class="el-icon-delete"></i>
              </span>
            </span>
          </div>


      </el-upload>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
      </div>
      <div class="column upload-mobile">
        <p class="modal__label">Mobile</p>
        <el-upload
        action="#"
        accept=" .jpg, .jpeg, .png"
        list-type="picture-card"
        :on-change="handleImageMobile"
        :multiple="false"
        :auto-upload="false">
          <i slot="default" class="el-icon-plus"></i>
          <img v-if="parentData.backgroundSrcMobile" class="el-upload--picture-uploaded" slot="default" :src="parentData.backgroundSrcMobile">
          <div slot="file" slot-scope="{file}">
            <img
              class="el-upload-list__item-thumbnail"
              :src="file.url" alt=""
            />
            <span class="el-upload-list__item-actions">
              <span
                class="el-upload-list__item-preview"
                @click="handlePictureCardPreview(file)"
              >
                <i class="el-icon-zoom-in"></i>
              </span>
              <span
                v-if="!disabled"
                class="el-upload-list__item-delete"
                @click="handleRemove(file)"
              >
                <i class="el-icon-delete"></i>
              </span>
            </span>
          </div>


      </el-upload>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
      </div>
    </div>

    <div class="_mt-15">
      <p class="modal__label">Линк кнопки</p>
      <el-form-item
          prop="inputButtonLink"
          :rules="[ { required: true, message: 'Ссылка обязательна'} ]"
      >
        <el-input type="textarea" v-model="parentData.inputButtonLink"></el-input>
      </el-form-item>
    </div>

    <div class="justify-start _mt-15">
      <div class="_mt-15">
        <p class="modal__label">Укажите тег</p>
        <el-form-item
          prop="tagName"
          :rules="[ { required: true, message: 'Тег обязателен'} ]"
        >
          <el-select v-model="parentData.tagName" placeholder="Выберите тег">
            <template v-for="tag in getTags">
              <el-option
              v-if="tag.id !== 0"
              :key="tag.tagName"
              :label="tag.tagName"
              :value="tag.id">
            </el-option>
            </template>

          </el-select>
        </el-form-item>

        <p class="modal__label _mt-15">Укажите вендора</p>
        <el-form-item
          prop="vendorName"
          :rules="[ { required: true, message: 'Вендор обязателен'} ]"
        >
          <el-select v-model="parentData.vendorName" placeholder="Выберите вендора">
            <template v-for="vendor in getVendors">
              <el-option
                v-if="vendor.id !== 0"
                :key="vendor.vendorName"
                :label="vendor.vendorName"
                :value="vendor.id">
              </el-option>
            </template>
          </el-select>
        </el-form-item>
      </div>


        <div class="column addtask-radios">
          <el-radio-group v-model="parentData.visible" @change="visibleChangeHandler">
            <template v-for="group in userTypes">
              <el-radio 
                v-if="Object.keys(excludes).length === 0 || excludes.userTypes && 
                !excludes.userTypes.includes(parseInt(group.id))" 
                class="addtask-radio" 
                :label="group.id"
                :key="group.id">
                  {{ group.groupName }}
              </el-radio>
            </template>
          </el-radio-group>

        </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import moment from 'moment';
export default {
  name: 'WestSideForm',
  props: ['parentData', 'date', 'inputPosition', 'forbiddenDays', 'exclude', 'mode'],
  data() {
    const vm = this;
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      excludes: {},
      startIndex: 0,
      startVisible: 0,
      startDates: 0,
      tags: [
        { tagName: 'test', label: 'test' },
        { tagName: 'test1', label: 'test1' },
        { tagName: 'test2', label: 'test2' },
      ],
      vendors: [
        { vendorName: 'DOBRO', label: 'DOBRO' },
        { vendorName: 'test', label: 'test' },
      ],
      pickerOptions: {
        disabledDate(time) {
          if (vm.disabledDates) {
            const forbiddenDate = new Date(vm.disabledDates[0]);
            time = moment(time).format('YYYY-MM-DD');
            return vm.disabledDates.indexOf(time)>-1;
          }
        },
      }
    };
  },
  computed: {
    ...mapGetters(['getTags', 'getVendors', 'getUserTypes']),
    disabledDates: function() {
       return this.getForbiddenDates(this.parentData.inputPosition, this.parentData.visible);
    },
    userTypes: function() {
      let filter = [],
          filteredArr = [];
      if ( this.$route.name === 'AmwayUA' ) {
        filter = ['Public', 'RC', 'PA', 'ABO'];
        this.updateFiltredArr(filter, filteredArr);
      } else {
        filter = ['Public', 'RC', 'SE', 'VIP', 'VIP+', 'ABO'];
        this.updateFiltredArr(filter, filteredArr);
      }

      return filteredArr;
    },
  },
  created() {
    Object.assign(this.excludes, this.exclude);
    this.startIndex = this.parentData.inputPosition;
    this.startVisible = this.parentData.visible;
    this.startDates = this.parentData.dateSpace;

  },
  mounted() {
      this.parentData.dateSpace = this.date;
      this.dialogImageUrl = this.parentData.backgroundSrc;
  },
  methods: {
    handleRemove(file) {
      file.url = '';
      this.dialogImageUrl = '';
      this.dialogVisible = false;
      const uploadedImg = document.querySelector('.el-upload-list__item');
      uploadedImg.remove();
      
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handlePicker(e) {
      this.$emit('pick', this.date);
    },
    handleImage(file) {
      this.parentData.backgroundSrc = file.url;
      this.parentData.image = file;
    },
    handleImageMobile(file) {
      this.parentData.backgroundSrcMobile = file.url;
      this.parentData.imageMobile = file;
    },
    visibleChangeHandler() {
        this.parentData.dateSpace = [];
    },
    changePosition(index) {
      this.disabledDates = this.getForbiddenDates(this.parentData.inputPosition, this.parentData.visible);
    },
    getForbiddenDates(index, visible) {
      let dates = [];
      let excludesDates = [];
      const start = moment(this.startDates[0]).format("YYYY-MM-DD");
      const end = moment(this.startDates[1]).format("YYYY-MM-DD");
      if (this.forbiddenDays.hasOwnProperty(index) && this.forbiddenDays[index].hasOwnProperty(visible)) {
        dates = this.forbiddenDays[index][visible];
        if (index == this.startIndex && this.startVisible == visible) {
          for (let index in dates) if (dates.hasOwnProperty(index)) {
            const date = moment(dates[index], "YYYY-MM-DD");
            if (!date.isBetween(start, end, 'days', '[]')) {
              excludesDates.push(date.format("YYYY-MM-DD"));
            }
          }
          dates = excludesDates;
        }
      }
      return dates;
    },
    updateFiltredArr(filter, arr) {
      filter.forEach(el => {
        arr.push(
          this.getUserTypes.find(obj => obj.groupName === el)
        )
      })
    },
  },
  watch: {
    'parentData.inputPosition': function() {
      this.parentData.dateSpace = []
    },
  }
}
</script>

<style lang="scss" scoped>
  .form_west-side {
    box-sizing: border-box;
    border-radius: 2px;
    padding: 35px 0;
    margin-right: 30px;
    width: 392px;
    flex-shrink: 0;
  }
  .modal__label {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -.5px;
    margin-bottom: 10px;

    color: #56565A;
  }

  .el-checkbox {
    display: block;
  }

  .el-upload--picture-uploaded {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }

  .upload-desktop .el-upload--picture-uploaded {
    object-position: left;
  }

  .addtask-radio {
    margin-bottom: 7px;
  }

  .task-position {
    width: 44px;
  }

  ._ml-15 {
    margin-left: 10px;
  }

  .upload-desktop {
    flex-shrink: 0;
    width: 267px;
    margin-right: 15px;
  }

  .upload-mobile {
    width: 100%;
  }

  .justify-start {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .addtask-radios {
    margin-left: 38px;
    padding-top: 28px;
  }
</style>
<style>
  .el-upload--picture-card {
    position: relative;
  }

  .el-date-editor.el-range-editor {
    width: 192px !important;
  }
</style>